"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionalExpander = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _expander = require("../expander");

var _core = require("@emotion/core");

var _excluded = ["enabled", "titleText", "children"];

var OptionalExpander = function OptionalExpander(_ref) {
  var enabled = _ref.enabled,
      titleText = _ref.titleText,
      children = _ref.children,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  if (enabled) {
    return (0, _core.jsx)(_expander.Expander, (0, _extends2.default)({}, rest, {
      titleText: titleText,
      contentSpacing: "S100",
      size: _expander.ExpanderSize.Small
    }), children);
  }

  return (0, _core.jsx)(_react.default.Fragment, null, children);
};

exports.OptionalExpander = OptionalExpander;